import { Container, Button, Spinner } from 'react-bootstrap';

export const ControlButtons = ({
	onNext = () => {},
	onPrev = () => {},
	onSubmit = () => {},
	disablePrev = true,
	disableNext = false,
	finalStep = false,
	enableLoading = false,
}) => {
	return (
		<>
			<Container className="p-0 mt-4 buttonsRight">
				<Button size="lg" disabled={disablePrev} onClick={onPrev}>
					Previous
				</Button>
				{finalStep === false ? (
					<Button size="lg" disabled={disableNext} onClick={onNext}>
						Next
					</Button>
				) : (
					<>
						{enableLoading === true ? (
							<>
								<Button size="lg" variant="primary" disabled>
									<Spinner
										as="span"
										animation="border"
										size="lg"
										role="status"
										aria-hidden="true"
										variant=""
									/>
									<span className="visually-hidden"> Loading...&nbsp;</span>
								</Button>{' '}
							</>
						) : (
							<>
								<Button size="lg" disabled={disableNext} onClick={onSubmit}>
									Submit
								</Button>
							</>
						)}
					</>
				)}
			</Container>
		</>
	);
};
